import { axiosWithTimeOut } from '../utilities/axios';
import ApplicationSettings from './ApplicationSettings';

class GeolocationApi {
  static fetchGeolocation() {
    const geolocationBaseApiUrl = ApplicationSettings.getApplicationSetting('geolocationBaseApiUrl');
    return axiosWithTimeOut(3000)
      .get(`${geolocationBaseApiUrl}v1/geolocation`)
      .then(res => res.data);
  }
}

export default GeolocationApi;
